var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.5C18.75 9.18479 20.067 6.00537 22.4112 3.66117C24.7554 1.31696 27.9348 0 31.25 0L68.75 0C72.0652 0 75.2446 1.31696 77.5888 3.66117C79.933 6.00537 81.25 9.18479 81.25 12.5V87.5C81.25 90.8152 79.933 93.9946 77.5888 96.3388C75.2446 98.683 72.0652 100 68.75 100H31.25C27.9348 100 24.7554 98.683 22.4112 96.3388C20.067 93.9946 18.75 90.8152 18.75 87.5V12.5ZM56.25 81.25C56.25 79.5924 55.5915 78.0027 54.4194 76.8306C53.2473 75.6585 51.6576 75 50 75C48.3424 75 46.7527 75.6585 45.5806 76.8306C44.4085 78.0027 43.75 79.5924 43.75 81.25C43.75 82.9076 44.4085 84.4973 45.5806 85.6694C46.7527 86.8415 48.3424 87.5 50 87.5C51.6576 87.5 53.2473 86.8415 54.4194 85.6694C55.5915 84.4973 56.25 82.9076 56.25 81.25Z",
    fill: "#6E503D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5e34f81c4176a430c9d5cc9f9ab24634.svg";
export { ForwardRef as ReactComponent };